export const _routes = [
  { title: 'Locations', route: '/locations?tab=locations' },
  { title: 'Addresses', route: '/locations?tab=addresses' },
  { title: 'Zones', route: '/locations?tab=zones' },
  { title: 'Upload Location', route: '/uploadLocation' },
  { title: 'Bulk Upload', route: '/bulkUpload' },
  { title: 'Bulk Upload (New)', route: '/bulkUpload/management' },
  { title: 'Countries', route: '/static/countries' },
  { title: 'States', route: '/static/states' },
  { title: 'Cities', route: '/static/cities' },
  { title: 'Unlocodes', route: '/static/unlocodes' },
  { title: 'Job Tracking', route: '/jobTracking' }
];
